import React, { useEffect, useState, useRef } from 'react';
import MobileProductManagement from '../../components/app/MobileProductManagement';
import { useDispatch, useSelector } from 'react-redux';
import { sort } from '../../lib/commonFunc/commonFunc';
import moment from 'moment';
import {
    init,
    loadAllKioskProduct,
    deleteKioskProduct,
    changeKioskProductActive,
    changeKioskProductOrder,
    changeKioskProductState,
    initRes
} from '../../modules/app/kioskProduct'
import KioskProductManagement from '../../components/app/KioskProductManagement';
import { readClub } from '../../modules/clubs/club';
import dotenv from 'dotenv'
dotenv.config()

const KioskProductManagementContainer = ({ history }) => {
    const {
        club,
        socketKey,
        kioskProductList,
        deleteRes,
        activeRes,
        stateChangeRes,
        kioskProduct
    } = useSelector(({ kioskProduct, club, socket }) => ({
        club: club.defaultClub,
        socketKey: socket.socketKey,
        kioskProductList: kioskProduct.kioskProductList,
        deleteRes: kioskProduct.deleteRes,
        activeRes: kioskProduct.activeRes,
        stateChangeRes: kioskProduct.stateChangeRes,
        kioskProduct: kioskProduct,
    }));

    console.log("kioskProductList : ", kioskProductList)

    console.log("kioskProduct : ", kioskProduct)
    const dispatch = useDispatch()

    const [deleteProduct, setDeleteProduct] = useState({})
    const [isActive, setIsActive] = useState(0)

    const onClickRegist = () => {
        history.push(`/kiosk/product/regist`)
    }

    const onClickSetting = () => {
        history.push(`/kiosk/product/setting`)
    }

    const deleteAWSImage = (imageName) => {
        //--> delete
        // var AWS = require('aws-sdk');
        // var s3 = new AWS.S3({ accessKeyId: process.env, secretAccessKey: process.env.REACT_APP_AWS_ACCESS_KEY, region: 'ap-northeast-2' });

        // var params = {
        //     Bucket: 'healthnavi',
        //     Delete: { // required
        //         Objects: [ // required
        //             {
        //                 Key: 'clubdata/' + imageName
        //             },
        //         ],
        //     },
        // };

        // s3.deleteObjects(params, function (err, data) {
        //     if (err) console.log(err, err.stack); // an error occurred
        //     else console.log(data);           // successful response
        // });
    }

    const onDeleteMobileProduct = () => {

        let templateImage = [
            'mobileProduct/1_mobileProdcut_1636423221_0.2957728325689166.jpg',
            'mobileProduct/1_mobileProdcut_1634883220_0.6677131199215078.jpg',
            'mobileProduct/1_mobileProdcut_1636423250_0.38462252196981916.jpg',
            'mobileProduct/1_mobileProdcut_1636423303_0.29091055009463007.jpg',
            'mobileProduct/1_mobileProdcut_1636423333_0.5439604089177359.jpg',
            'mobileProduct/1_mobileProdcut_1636422778_0.7797188036092573.jpg',
            'mobileProduct/1_mobileProdcut_1636422748_0.39779295718879304.jpg',
            'mobileProduct/1_mobileProdcut_1635732827_0.36337724224361123.jpg',
            'mobileProduct/1_mobileProdcut_1635733458_0.5221249271880171.jpg',
            'mobileProduct/1_mobileProdcut_1635734027_0.3800332508929172.jpg',
            'mobileProduct/1_mobileProdcut_1635734625_0.5165348459898818.jpg',
            'mobileProduct/1_mobileProdcut_1635734628_0.28488481557001255.jpg',
            'mobileProduct/1_mobileProdcut_1635734631_0.5789395696749773.jpg',
        ]

        for (let i = 0; i < deleteProduct.images.length; i++) {
            if ((deleteProduct.images[i]).indexOf('template') == -1 && (deleteProduct.images[i]).indexOf('productMainImage') == -1) {
                deleteAWSImage(deleteProduct.images[i])
            }
        }

        const arr1 = deleteProduct.body.split('img').map(v => v.includes('src') === true && v.split("src="));
        const arr2 = arr1.map(v => v && v[1]?.split("></p"))
        const arr3 = arr2.map(v => v && v[0].slice(1, v[0]?.length - 1)).filter(v => v !== false).filter(item => { return item != null });

        for (let i = 0; i < arr3.length; i++) {
            if (!templateImage.includes(arr3[i].split('clubdata/')[1])) {
                deleteAWSImage(arr3[i].split('clubdata/')[1])
            }
        }

        dispatch(deleteKioskProduct({
            clubID: club.clubID,
            clubKioskSalesItemID: deleteProduct.clubKioskSalesItemID,
            socketKey: socketKey
        }))
    }

    const onClickMobileProduct = (selectProduct) => {
        history.push({
            pathname: `/kiosk/product/regist`,
            state: { selectProduct, isEdit: true }
        });
    }

    const onChangeIsActive = (selectProductID, isActive) => {
        for (let i = 0; i < kioskProductList.length; i++) {
            if(kioskProductList[i].clubKioskSalesItemID == selectProductID)
            {
                if(kioskProductList[i].salesType == 100 && isActive == 0)
                {
                    alert("구독 상품을 비활성화 해도 기존 구독은 계속 유지됩니다.")
                    break;
                }
            }
        }
        setIsActive(isActive)
        dispatch(changeKioskProductActive({
            clubID: club.clubID,
            clubKioskSalesItemID: selectProductID,
            isActive: Number(isActive),
            socketKey: socketKey
        }))
    }

    const onChangeProductOrder = (clubKioskSalesItemID, direction) => {
        dispatch(changeKioskProductOrder({
            clubID: club.clubID,
            clubKioskSalesItemID,
            direction,
            socketKey: socketKey
        }))
    }

    const onChangeKioskProductState = () => {
        let state = 0

        if (club.kioskProductState === 1) state = 0
        if (club.kioskProductState === 0) state = 1

        dispatch(changeKioskProductState({
            clubID: club.clubID,
            kioskProductState: state,
            socketKey: socketKey
        }))
    }

    // if(club.mobileProductState != 2) {
    //   history.push(`/app/product/admission`);
    // }

    useEffect(() => {
        if (!club || !club.clubID) return;
        dispatch(init())
        dispatch(loadAllKioskProduct({
            clubID: club.clubID,
            socketKey: socketKey
        }))
    }, [club]);

    useEffect(() => {
        if (deleteRes && deleteRes == 1) {
            alert('선택한 상품을 삭제했습니다.')
            dispatch(init())
            setDeleteProduct({})
            dispatch(loadAllKioskProduct({
                clubID: club.clubID,
                socketKey: socketKey
            }))
        }
    }, [deleteRes]);

    useEffect(() => {
        if (activeRes && activeRes == 1) {
            if (isActive == 0) {
                alert('선택한 키오스크 상품을 판매하지 않습니다.')
            } else if (isActive == 1) {
                alert('선택한 키오스크 상품을 판매합니다.')
            }
            dispatch(init())
            dispatch(loadAllKioskProduct({
                clubID: club.clubID,
                socketKey: socketKey
            }))
        }
    }, [activeRes]);

    useEffect(() => {
        if (stateChangeRes && stateChangeRes === 1) {
            if (club && club.kioskProductState === 0) {
                alert("키오스크 상품 판매 기능을 사용합니다.")
            } else {
                alert("키오스크 상품 판매 기능 사용을 중단합니다.")
            }
            dispatch(initRes())
            dispatch(
                readClub({
                    clubID: club.clubID,
                    socketKey: socketKey,
                }),
            );
        }
    }, [stateChangeRes])

    return (
        <KioskProductManagement
            salesInfo={null}
            onClickRegist={onClickRegist}
            onClickSetting={onClickSetting}
            mobileProductList={kioskProductList}
            onDeleteMobileProduct={onDeleteMobileProduct}
            deleteProduct={deleteProduct}
            setDeleteProduct={setDeleteProduct}
            onChangeIsActive={onChangeIsActive}
            onClickMobileProduct={onClickMobileProduct}
            onChangeProductOrder={onChangeProductOrder}
            mobileProductState={club && club.kioskProductState}
            onChangeMobileProductState={onChangeKioskProductState}
        />
    );
};

export default KioskProductManagementContainer;
